import React, { useEffect } from "react";
import {
  MinusCircleOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  Upload,
} from "antd";
import { H6 } from "../../../../AbstractElements";
import TextArea from "antd/lib/input/TextArea";
import { useState } from "react";
import { useRef } from "react";
import { TermsAndCondtitionsAPI } from "../../../../api";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { useAPIUser } from "../../../../_helper/User/UserProvider";
import { LogEvents, LoggerContext } from "../../../../context/logging";

const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});

const PaymentTerms = (props) => {
  const { defaultPaymentTerms } = props;
  const logger = React.useContext(LoggerContext);

  const [form] = Form.useForm();
  const { Option } = Select;
  const { userDetails, setUserDetails } = useAPIUser();
  const [conditions, setConditions] = useState([]);
  const [terms, setTerms] = useState([]);
  const [formList, setFormList] = useState(
    props.formList ?? [
      {
        term: "Payment before Delivery",
        percentage: 0,
        deadline: moment(),
        total: 0,
      },
      {
        term: "Payment after Delivery",
        percentage: 0,
        deadline: moment(),
        total: 0,
      },
      {
        term: "Payment after invoice generation",
        percentage: 0,
        deadline: moment(),
        total: 0,
      },
    ]
  );
  useEffect(() => {
    fetchTerms();
  }, []);
  const fetchTerms = () => {
    axios
      .get(
        `${TermsAndCondtitionsAPI}` +
          "?organisation_id=" +
          props.settings?.user?.organisation?.organisation_id
      )
      .then((res) => {
        setTerms(res.data);
      });
  };
  const onAdd = () => {
    var arr = formList;
    arr = [
      ...arr,
      {
        term: null,
        percentage: 0,
        deadline: moment(),
        total: 0,
      },
    ];
    setFormList(arr);
    logger.log(LogEvents.addCondition, {});
  };
  const onRemove = (index) => {
    var arr = formList;
    var newArr = [];
    for (var i = 0; i < arr.length; i++) {
      console.log(i, arr[i], index, "hello", i === index);
      if (i !== index) {
        console.log(i, arr[i], index, "hello2");
        newArr.push(arr[i]);
      }
    }
    console.log(newArr, "newArr");
    setFormList([...newArr]);
  };
  const onChangeInput = (value, index, name) => {
    var arr = formList;
    arr[index][name] = value;
    setFormList([...arr]);
    props.setPaymentTerms([...arr]);
    console.log(arr);
  };
  useEffect(() => {}, [formList]);
  useEffect(() => {
    if (defaultPaymentTerms?.length > 0) {
      setFormList([...defaultPaymentTerms]);
    }
  }, [defaultPaymentTerms]);
  const termsOptions = terms?.map((each) => (
    <Option key={each.id} value={each.id}>
      {each?.title}
    </Option>
  ));
  const full_percentage = formList?.reduce((acc, obj) => {
    return acc + obj.percentage;
  }, 0);
  return (
    <React.Fragment>
      <Form
        form={form}
        name="dynamic_form_nest_item"
        // onFinish={onFinish}
        // autoComplete="off"
        // onChange={onChange}
      >
        {formList?.map((each, index) => (
          <Space align="baseline">
            <Form.Item>
              <Input
                value={each.term}
                placeholder="Term"
                onChange={(e) => {
                  onChangeInput(e.target.value, index, "term");
                }}
              />
            </Form.Item>
            <Form.Item>
              <InputNumber
                min={0}
                max={100}
                value={each.percentage}
                formatter={(value) => `${value}%`}
                parser={(value) => value.replace("%", "")}
                onChange={(e) => {
                  onChangeInput(e, index, "percentage");
                }}
              />
            </Form.Item>
            <Form.Item>
              <DatePicker
                placeholder="Select Deadline"
                value={moment(each.deadline)}
                onChange={(e) => {
                  onChangeInput(e, index, "deadline");
                }}
              />
            </Form.Item>
            <MinusCircleOutlined onClick={() => onRemove(index)} />
          </Space>
        ))}
        <Form.Item>
          <Button
            type="dashed"
            onClick={() => onAdd()}
            block
            icon={<PlusOutlined />}
          >
            Add Condition
          </Button>
        </Form.Item>
      </Form>
      <div className="my-2">Total : {full_percentage}%</div>
      {full_percentage !== 100 ? (
        <span style={{ color: "red" }}>The total should add upto 100%.</span>
      ) : null}
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(PaymentTerms);
